import firebase from 'firebase/app';
import 'firebase/firestore';

class PaymentService {
    #_fr = firebase.firestore();

    async getPayments() {
        return await this.#_fr.collection("paymentMethods").get();
    }

    async updatePayment(documentId: string, newState: boolean) {
        return await this.#_fr.collection("paymentMethods").doc(documentId).set({
            isActive: newState,
        }, { merge: true });
    }
}

export default PaymentService;